import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContextInterface, LearnerProfileConceptInterface, LearnerProfileStrandInterface } from '../+models';
import { RecommendationInterface } from '../+models/Recommendation.interface';
import { BearerHttpService } from '../bearer-http';
import { DalOptions, DAL_OPTIONS } from '../dal.module';

export interface GetRecommendationsResponseInterface {
  recommendations?: RecommendationInterface[];
  learnerProfileConcepts?: LearnerProfileConceptInterface[];
  learnerProfileStrand?: LearnerProfileStrandInterface;
}

@Injectable({
  providedIn: 'root',
})
export class RecommendationService {
  private bearerHttpService = inject(BearerHttpService);
  private dalOptions = inject<DalOptions>(DAL_OPTIONS);

  public getRecommendationsForContext(
    context: ContextInterface,
    options?: { includeLearnerProfileConcepts?: boolean; includeLearnerProfileStrand?: boolean }
  ): Observable<GetRecommendationsResponseInterface> {
    const url = `${this.dalOptions.apiBaseUrl}/api/Adaptemy/recommendations-for-context`;
    const { includeLearnerProfileConcepts, includeLearnerProfileStrand } = options || {};

    const params = new HttpParams({
      fromObject: {
        context: JSON.stringify(context),
        includeLearnerProfileConcepts: includeLearnerProfileConcepts ?? false,
        includeLearnerProfileStrand: includeLearnerProfileStrand ?? false,
      },
    });

    return this.bearerHttpService.get<GetRecommendationsResponseInterface>(url, params).pipe(
      map(({ recommendations, learnerProfileConcepts, learnerProfileStrand }) => ({
        recommendations: (recommendations || []).map((r) => ({ ...r, courseGuid: context.course })),
        learnerProfileConcepts,
        learnerProfileStrand,
      }))
    );
  }
}
